module.exports = __webpack_public_path__ + "static/media/cybercrime.80acf586.png";